module.exports = __webpack_public_path__ + "static/media/arrow-right-white-hover.7dc002f5.svg";